export const ErrorCode = {
    NoError: 0,
    UnknownError: 1,
    UnknownDomain: 11,
    InvalidClientVersion: 12,
    InvalidAuthToken: 13,
    PlatformSessionExpired: 24,
} as const;
export type ErrorCodeValue = typeof ErrorCode[keyof typeof ErrorCode];
